module.exports = __webpack_public_path__ + "static/img/Decor_01.647c05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/Decor_01.png
// module id = YhzL
// module chunks = 0